import * as React from 'react';

import { GRADIENT_ARROW_WIDTH } from '../../../constants/arrows';
import { IHeadCategory } from '../../../types/promosPage';
import { Section } from '../../Section';
import { GradientRoundArrowLeft } from '../GradientRoundArrowLeft';
import { GradientRoundArrowRight } from '../GradientRoundArrowRight';
import { HeadCategoryLink } from '../HeadCategoryLink';
import { VerticalSlider } from '../VerticalSlider';

interface IHeadCategoriesProps {
  categories: IHeadCategory[];
  onClick(category: IHeadCategory, position: number): void;
}

export const HeadCategories: React.FC<IHeadCategoriesProps> = ({ categories, onClick }) => {
  const handleClick = React.useCallback(
    (category: IHeadCategory, position: number) => () => {
      onClick(category, position);
    },
    [onClick],
  );

  return (
    <Section data-testid="HeadCategories">
      <VerticalSlider
        rightArrow={GradientRoundArrowRight}
        leftArrow={GradientRoundArrowLeft}
        scrollOffset={GRADIENT_ARROW_WIDTH}
      >
        {categories.map((category, idx) => (
          <HeadCategoryLink
            key={idx}
            href={category.url}
            iconUrl={category.iconUrl}
            onClick={handleClick(category, idx + 2)}
            allCategory={idx === 0}
          >
            {category.name}
          </HeadCategoryLink>
        ))}
      </VerticalSlider>
    </Section>
  );
};
